(ns app.front.view.admin.migration.migrate-statcan-form-to-version-2
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/migrate-statcan-form-to-version-2
    :title     "Migrate Statcan form to version 2"
    :help-text (str "This task discovers existing StatCan form schemas and migrates them to version 2. "
                    "The task will only migrate StatCan forms that are in version 1, "
                    "and will not affect any other forms.")}
   match])

(def route
  {:name        :view/admin.migration.migrate-statcan-form-to-version-2
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/migrate-statcan-form-to-version-2]))}]})
